import { computed, inject } from '@angular/core';
import { SDKBaseFacadeService } from 'ets-fe-ng-sdk';
import { AuthenticationService } from '../authentication/authentication.service';

export abstract class BaseFacadeService extends SDKBaseFacadeService {
  readonly authenticationService = inject(AuthenticationService);
  readonly isLoggedIn = computed(() => this.authenticationService.isLoggedIn());
}
